import { useCallback, useEffect, useState } from "react";
import get from "../../utils/get";
import parseError from "../../utils/parseError";
import post from "../../utils/post";
import remove from "../../utils/remove";

const ManageExceptions = ({ users }) => {
  const [error, setError] = useState(null);
  const [exceptions, setExceptions] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedCannotChooseUserId, setSelectedCannotChooseUserId] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchExceptions = useCallback(async () => {
    setError(null);
    try {
      const response = await get("/exceptions");
      setExceptions(response.data || []);
    } catch (err) {
      setError(parseError(err));
    }
  }, []);

  useEffect(() => {
    fetchExceptions();
  }, [fetchExceptions]);

  const handleAddException = useCallback(
    async (e) => {
      e.preventDefault();
      if (!selectedUserId || !selectedCannotChooseUserId) {
        return;
      }
      
      setError(null);
      setLoading(true);
      
      const confirmed = window.prompt("Password");
      if (confirmed !== process.env.REACT_APP_MASTER_PASSWORD) {
        setLoading(false);
        return window.alert("Password is invalid");
      }
      
      try {
        await post("/exception", {
          userId: parseInt(selectedUserId),
          cannotChooseUserId: parseInt(selectedCannotChooseUserId),
        });
        setSelectedUserId("");
        setSelectedCannotChooseUserId("");
        fetchExceptions();
      } catch (err) {
        setError(parseError(err));
      }
      setLoading(false);
    },
    [selectedUserId, selectedCannotChooseUserId, fetchExceptions]
  );

  const handleRemoveException = useCallback(
    async (id) => {
      setError(null);
      const confirmed = window.prompt("Password");
      if (confirmed !== process.env.REACT_APP_MASTER_PASSWORD) {
        return window.alert("Password is invalid");
      }
      try {
        await remove("/exception/" + id);
        fetchExceptions();
      } catch (err) {
        setError(parseError(err));
      }
    },
    [fetchExceptions]
  );

  const availableCannotChooseUsers = users.filter(
    (user) => user.id !== parseInt(selectedUserId)
  );

  return (
    <div id="manageExceptions">
      <h3>Manage Exceptions</h3>
      {error ? <div className="error">{error}</div> : null}
      
      <form onSubmit={handleAddException}>
        <div className="exceptionForm">
          <select
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
            disabled={loading}
          >
            <option value="">Select user...</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
          
          <span className="arrow">→ cannot choose →</span>
          
          <select
            value={selectedCannotChooseUserId}
            onChange={(e) => setSelectedCannotChooseUserId(e.target.value)}
            disabled={loading || !selectedUserId}
          >
            <option value="">Select user...</option>
            {availableCannotChooseUsers.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
          
          <button
            type="submit"
            disabled={!selectedUserId || !selectedCannotChooseUserId || loading}
          >
            Add Exception
          </button>
        </div>
      </form>

      <div className="exceptionsList">
        {exceptions.length === 0 ? (
          <div className="noExceptions">No exceptions configured</div>
        ) : (
          exceptions.map((exception) => (
            <div key={exception.id} className="exception">
              <div className="exceptionInfo">
                <span className="userName">{exception.userName}</span>
                <span className="arrow">→ cannot choose →</span>
                <span className="userName">{exception.cannotChooseName}</span>
              </div>
              <div
                className="remove"
                onClick={() => handleRemoveException(exception.id)}
              >
                &times;
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ManageExceptions;
